import React from 'react'
import classes from './togglebar.module.css'
import classNames from 'classnames'
import ToggleBarLoader from '../loaders/ToggleBarLoader'

const ToggleBar = ({ links, changeActive, activeId, loading = false }) => {
    return (
        <div className={classes.toggleLinks}>
            {loading ? (
                <>
                    <ToggleBarLoader />
                    <ToggleBarLoader />
                    <ToggleBarLoader />
                </>
            ) : (
                links.map(({ text, badge = false, id }) => (
                    <button
                        className={classNames(
                            classes.toggleLink,
                            activeId === id && classes.toggleLinkActive
                        )}
                        onClick={() => changeActive(id)}
                        key={id}
                    >
                        {text}
                        {badge && (
                            <ToggleBadge variant={badge.variant}>
                                {badge.text}
                            </ToggleBadge>
                        )}
                    </button>
                ))
            )}
        </div>
    )
}

const badgeVariants = {
    blue: classes.toggleBadgeBlue,
    gray: classes.toggleBadgeGray,
}

const ToggleBadge = ({ variant, children }) => (
    <span className={[classes.toggleBadge, badgeVariants[variant]].join(' ')}>
        {children}
    </span>
)

export default ToggleBar
